import { render, staticRenderFns } from "./AvitoCommercialBuildingUpdateDialog.vue?vue&type=template&id=86e1e0b8&"
import script from "./AvitoCommercialBuildingUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./AvitoCommercialBuildingUpdateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports